export const SVG_W = 24;
export const SVG_H = 40;
export const TRUNK_X = 7;
export const STROKE_WIDTH = 0.5;
export const NESTED_CHILDREN_SPACING = 4;
export const ROW_TOGGLE_SIZE = 22;
export const FIRST_TREE_LEVEL = 1;
